

export var VcValidation = (function () {
	
    
    return {
      validateEmail:function(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },
      validatePassword:function(password) {
        // Require at least 8 chars with uppercase, lowercase, and number
        if (!password || password.length < 8) return false;
        const hasUpper = /[A-Z]/.test(password);
        const hasLower = /[a-z]/.test(password);
        const hasNumber = /[0-9]/.test(password);
        return hasUpper && hasLower && hasNumber;
      },
      getPasswordRequirements:function() {
        return 'Password must be at least 8 characters with uppercase, lowercase, and a number';
      },
      validateAuthCode:function(code) {
        return code && code.length===5;
      },
    }
}());
